import { InjectionToken } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BusinessInsuranceFormType } from 'src/app/_services/types/business-insurances.types';

import { BusinessSharedFlowInsurances } from '../basic-shared-flow/basic-shared-flow.service';
import { AbstractCompanyInsuranceService } from '../company-insurance.service';

export const COMPANY_INSURANCE_SERVICE_TOKEN = new InjectionToken<
  AbstractCompanyInsuranceService<FormGroup<BusinessInsuranceFormType>>
>('CompanyInsuranceService');

export const BASIC_COMPANY_FLOW_INJECTION_TOKENS = {
  formDatalayer: new InjectionToken('BasicCompanyFlowFormDatalayer'),
  offersDatalayer: new InjectionToken('BasicCompanyFlowOffersDatalayer'),

  offersLoginRoute: new InjectionToken('BasicCompanyFlowOffersLoginRoute'),
  offersRegisterRoute: new InjectionToken('BasicCompanyFlowOffersRegisterRoute'),
  offersPreviousRoute: new InjectionToken('BasicCompanyFlowOffersPreviousRoute'),
  offersNextRoute: new InjectionToken('BasicCompanyFlowOffersNextRoute'),

  loginStep: new InjectionToken('BasicCompanyFlowLoginStep'),
  loginNextRoute: new InjectionToken('BasicCompanyFlowLoginNextRoute'),
  loginDatalayer: new InjectionToken('BasicCompanyFlowLoginDataLayer'),
  loginPrevious: new InjectionToken('BasicCompanyFlowLoginPrevious'),

  registerDatalayer: new InjectionToken('BasicCompanyFlowRegisterDataLayer'),

  endRoute: new InjectionToken('BasicCompanyFlowDataLayer'),
  endScreenDatalayer: new InjectionToken('BasicCompanyFlowDataLayer'),
  endScreenStep: new InjectionToken('BasicCompanyFlowStep'),
  endScreenSteps: new InjectionToken('BasicCompanyFlowSteps'),
};
export const BASIC_COMPANY_INSURANCE_BASE_URL = new InjectionToken<string>(
  'BasicCompanyInsuranceBaseUrl',
);

export const BASIC_COMPANY_INSURANCE_TYPE = new InjectionToken<BusinessSharedFlowInsurances>(
  'BasicCompanyFlowInsuranceType',
);
